import { Box, Grid, Masonry } from "@dladio/core-ui"
import AccountInformationForm from "./components/AccountInformationForm/AccountInformationForm"
import Address from "./components/Address/Address"
import BasicAccountInformation from "./components/BasicAccountInformation/BasicAccountInformation"
import ExtraChargesAndTradingTerms from "./components/ExtraCharges/ExtraChargesAndTradingTerms"
import Footer from "./components/Footer/Footer"
import GradesAndStatus from "./components/Grades&Status/GradesAndStatus"
import Header from "./components/Header/Header"
import OrderInformationForm from "./components/OrderInformationFrom/OrderInformationForm"
import AddSalesOrderLine from "./components/SalesOrderLineTable/components/AddSalesOrderLine/AddSalesOrderLine"
import SalesOrderLineTable from "./components/SalesOrderLineTable/SalesOrderLineTable"
import ShippingInformationForm from "./components/ShippingInformation/ShippingInformation"
import Summery from "./components/Summery/Summery"
import VisibleWrapper from "./components/VisibleWrapper/VisibleWrapper"

const Home = () => {
    return (
        <>
            <Header />
            <Masonry>
                <Box title="Account Information">
                    <AccountInformationForm />
                </Box>
                <Box title="Order Information">
                    <OrderInformationForm />
                </Box>
                <BasicAccountInformation />
                <Address />
                {/* <GradesAndStatus /> */}
                <ShippingInformationForm />
                <ExtraChargesAndTradingTerms />
            </Masonry>
            <SalesOrderLineTable />
            <Grid>
                <AddSalesOrderLine />
                <Summery />
            </Grid>
            <Footer />
        </>
    )
}

export default Home